import angular from 'angular';

/**
 * @name DashboardController
 * @description description
 */
class DashboardController {
  /**
   * @name name
   * @description description
   * @param {type} DashboardData Description
   * @param {type} Project Description
   * @param {type} Operators Description
   * @param {type} ShopHours Description
   * @param {type} Artists Description
   * @param {type} Session Description
   * @param {type} Appointments Description
   */
  constructor(
    DashboardData,
    Project,
    Operators,
    ShopHours,
    Artists,
    Session,
    Appointments
  ) {
    this.dashboardData = DashboardData;
    this.project = Project;
    this.operators = Operators;
    this.shopHours = ShopHours;
    this.Artists = Artists;
    this.session = Session;
    this.appointments = Appointments;
    this.isNew = false;
    this.appointmentCount = 0;
    this.shopHourCount = 0;
    this.artistCount = 0;

    if (this.session.activeState.role === 'operator') {
      this.operators.get(this.session.collector.operator.id).then(collector => {
        this.isNew = collector.operator.is_new_user;
        if (this.isNew) {
          let search = {
            page: 1,
            status: undefined,
            sort: 'appointmentDatetime',
            search: ''
          };
          this.appointments.get(search).then(appointments => {
            this.appointmentCount = appointments.results.length;
          });

          this.shopHours
            .get(this.session.activeState.association.shop.id)
            .then(hours => {
              this.shopHourCount = hours.all.length;
            });

          this.Artists.fetchArtists().then(artists => {
            this.artistCount = artists.confirmed.length;
          });
        }
      });
    }
  }

  /**
   * @name closeTutorial
   * @description Close the tutorial screen and update the operator object with
   * is_new_user = false
   */
  closeTutorial() {
    this.isNew = false;
    this.operators.get(this.session.collector.operator.id).then(collector => {
      collector.operator.is_new_user = false;
      this.operators.update(collector.operator);
    });
  }
}

angular
  .module('inkfinder')
  .controller('DashboardController', DashboardController);



// WEBPACK FOOTER //
// ./components/dashboard/dashboard.controller.js